import React, { useState, useEffect } from "react";
import ResortCard from "./ResortCard.jsx";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";


const ResortList = ({ filters, hotelData }) => {
  const [page, setPage] = useState(1);
  console.log("the hotel data before filtering:",hotelData)
  const [isLoading, setIsLoading] = useState(true);

  // 1️⃣ Filter resorts
const filteredResorts = hotelData.filter((hotel) => {
  // ⭐ Rooms
  if (!Array.isArray(hotel.rooms) || hotel.rooms.length === 0) {
    return true;
  }

  const matchesRoom =
    filters.priceRange?.length || filters.roomViews?.length
      ? hotel.rooms.some((room) => {
          const price = Number(room.price_per_night) || 0;

          if (
            filters.priceRange?.length === 2 &&
            (price < filters.priceRange[0] ||
              price > filters.priceRange[1])
          ) {
            return false;
          }

          if (
            filters.roomViews?.length > 0 &&
            !filters.roomViews.includes(room.room_type)
          ) {
            return false;
          }

          return true;
        })
      : true;

  if (!matchesRoom) return false;

  // ⭐ Rating
  if (filters.average_rating) {
    if ((hotel.average_rating ?? 0) < filters.average_rating) {
      return false;
    }
  }

  // ⭐ Amenities
  if (filters.amenities?.length > 0) {
    if (!Array.isArray(hotel.amenities)) return false;

    const hotelAmenities = hotel.amenities.map(a =>
      a.name?.toLowerCase()
    );

    if (
      !filters.amenities.every(a =>
        hotelAmenities.includes(a.toLowerCase())
      )
    ) {
      return false;
    }
  }

  return true;
});


  // 2️⃣ Reset to first page when filters/hotelData change
  useEffect(() => {
    setPage(1);
  }, [filters, hotelData]);
  

  // 3️⃣ Paginate filtered list
  console.log("after filtrer: ",filteredResorts)
  const itemsPerPage = 3;
  const totalPages = Math.ceil(filteredResorts.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredResorts.slice(startIndex, endIndex);
  console.log("Filtered Resorts:", filteredResorts);
 

  return (
    <div className="resort-list" style={{width:"100%"}}>
      {currentItems.length > 0 ? (
        currentItems.map((hotel) => (
          <ResortCard key={hotel.id} resort={hotel} />
        ))
      ) : (
        <p style={{ textAlign: "center" }}>No resorts found.</p>
      )}

      {filteredResorts.length > 0 && (
        <div className="tourPaginationBar" style={{width:"100%"}}>
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default ResortList;
